<template>
    <div class="container section-menu-page">
        <div class="section-title-wrap">
            <h2 class="section-title">{{ titulo }}</h2>
        </div>
        <div>
            <div class="admin-home-card table-corporate-body main-menu-scroll-shell">
                <b-container style="padding: 18px 40px 40px; height: 100%;">
                    <div v-if="listaSubMenu.length > 0" class="menu-grid">
                        <div
                            v-for="subMenu in listaSubMenu"
                            :key="subMenu.id || subMenu.ruta"
                            class="menu-grid-item"
                        >
                            <div class="menu-item-wrapper">
                                <!-- Botón con clases condicionales y atributo disabled -->
                                <button
                                    type="button"
                                    class="md-card admin-menu-card-button"
                                    :class="{ 'btn-menu-disabled': !rutaExiste(subMenu.ruta) }"
                                    :disabled="!rutaExiste(subMenu.ruta)"
                                    @click="goToRoute(subMenu.ruta)"
                                    :title="!rutaExiste(subMenu.ruta) ? 'Módulo en construcción / No disponible' : ''"
                                >
                                    <div>
                                        <div>
                                            <div class="md-title-tarjeta">
                                                <span>{{ subMenu?.nombre }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </button>
                                <div class="div-description-fixed">
                                    <i class="fas fa-info-circle info-icon"></i>
                                    <span class="description-text">{{ subMenu?.descripcion || subMenu?.nombre }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-container>
            </div>
        </div>
    </div>
</template>

<script>
import SubMenu from '../../services/SubMenu';

export default {
    name: "Administrador",
    data: () => ({
        titulo: "Administrador",
        listaSubMenu: []
    }),

    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "Administrador",
                    users: "Usuarios",
                    usersd: "Administración de Usuarios",
                    menu: "Menús",
                    descripMenu: "Administración de Menús",
                    subMenu: "Submenús",
                    descripSubMenu: "Administración de submenus",
                    roles: "Roles",
                    descripRole: "Administración de Roles",
                    cargues: "Cargues",
                    carguesd: "Definición de formatos de cargues",
                }
            } else {
                return {
                    title: "Administrator",
                    users: "Users",
                    usersd: "Users Administration",
                    menu: "Menus",
                    descripMenu: "Menus Administration",
                    subMenu: "Submenus management",
                    descripSubMenu: "submenus description",
                    roles: "Role",
                    descripRole: "Role Administration",
                    cargues: "Uploads",
                    carguesd: "Upload Format Definition",
                }
            }
        }
    },
    methods: {
        // 1. Método mágico que verifica si la ruta existe en el router
        rutaExiste(ruta) {
            if (!ruta) return false;
            
            const rutas = this.$router?.options?.routes || [];
            // Normaliza la ruta quitando slashes al final
            const rutaNormalizada = ruta.replace(/\/+$/, '') || '/';
            
            return rutas.some((route) => {
                if (!route.path) return false;
                // Ignoramos rutas dinámicas (:) y comodines (*)
                if (route.path.includes(':')) return false;
                if (route.path.includes('*')) return false;
                
                const pathNormalizado = route.path.replace(/\/+$/, '') || '/';
                return pathNormalizado === rutaNormalizada;
            });
        },

        // 2. Modificación para que no redirija si la ruta no existe
        goToRoute(page) {
            if (this.rutaExiste(page)) {
                this.$router.push({ path: page });
            }
        }
    },
    mounted() {
        SubMenu.nombreMenu(this.$route.name)
            .then((res) => {
                this.titulo = res.data.titulo
            })
            .catch((err) => { console.log(err) })

        SubMenu.subMenuByMenuByRol(this.$route.name, this.$store.state.userRole)
            .then((res) => {
                this.listaSubMenu = res.data.submenus
            })
            .catch((err) => { console.log(err) })
    }
}
</script>

<style src="../main.css"></style>

<style scoped>
/* =========================================================
   ESTILOS PARA EL BOTÓN GRIS (Ruta no existente)
   ========================================================= */
.btn-menu-disabled {
    background-color: #e0e0e0 !important; /* Fondo gris claro */
    border: 1px solid #cccccc !important;
    cursor: not-allowed !important; /* Cursor de prohibido */
    pointer-events: none; /* Bloquea cualquier interacción con el mouse */
    opacity: 0.85;
}

.btn-menu-disabled .md-title-tarjeta span {
    color: #9e9e9e !important; /* Texto gris */
}

/* Opcional: hacer que la descripción de abajo también se vea gris para dar feedback visual */
.btn-menu-disabled + .div-description-fixed {
    opacity: 0.6;
}

.btn-menu-disabled + .div-description-fixed .description-text {
    color: #9e9e9e !important;
}
</style>